import React, { useState } from 'react';
import usdcIcon from '../../../images/icons/USDC.png';

/**
 * Icono del token de staking (USDC). Si el asset falla al cargar, muestra el símbolo en texto.
 */
const StakingTokenIcon = ({ symbol, className = '' }) => {
  const [imgOk, setImgOk] = useState(true);

  if (!imgOk) {
    return <span className={`staking-token-fallback ${className}`}>{symbol}</span>;
  }

  return (
    <img
      src={usdcIcon}
      alt=""
      className={`staking-token-icon ${className}`}
      onError={() => setImgOk(false)}
    />
  );
};

export default StakingTokenIcon;
